module.exports = __webpack_public_path__ + "047cd3f89fbe8ef683e2f4306b999676.jpg";